import { render, staticRenderFns } from "./SupportEntries.vue?vue&type=template&id=0596c995&scoped=true&"
import script from "./SupportEntries.vue?vue&type=script&lang=js&"
export * from "./SupportEntries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0596c995",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/unitech/keymetrics/pm2-io/pm2-io-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0596c995')) {
      api.createRecord('0596c995', component.options)
    } else {
      api.reload('0596c995', component.options)
    }
    module.hot.accept("./SupportEntries.vue?vue&type=template&id=0596c995&scoped=true&", function () {
      api.rerender('0596c995', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/App/Header/SupportEntries.vue"
export default component.exports